import React, { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Loader2 } from "lucide-react";

export const PinDialog = ({ open, onOpenChange, onConfirm, title = "Konfirmasi PIN", description = "Masukkan 6 digit PIN transaksi kamu untuk melanjutkan." }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(false);

  useEffect(() => {
    if (open) {
      setPin("");
      setError("");
      setLoading(false);
    }
  }, [open]);

  const submit = async (value) => {
    const finalPin = value || pin;
    if (finalPin.length !== 6 || loading) return;
    setLoading(true);
    setError("");
    try {
      await onConfirm(finalPin);
    } catch (e) {
      const msg = e?.response?.data?.detail || "PIN salah. Silakan coba lagi.";
      setError(msg);
      setPin("");
      setShake(true);
      setTimeout(() => setShake(false), 500);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !loading && onOpenChange(v)}>
      <DialogContent className="sm:max-w-md" data-testid="pin-confirmation-modal">
        <DialogHeader>
          <div className="mx-auto h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-2">
            <ShieldCheck className="h-6 w-6 text-primary" />
          </div>
          <DialogTitle className="text-center font-heading">{title}</DialogTitle>
          <DialogDescription className="text-center">{description}</DialogDescription>
        </DialogHeader>
        <div className={`flex flex-col items-center gap-4 py-2 ${shake ? "animate-shake" : ""}`}>
          <InputOTP
            maxLength={6}
            value={pin}
            onChange={setPin}
            onComplete={(v) => submit(v)}
            data-testid="pin-confirmation-otp"
          >
            <InputOTPGroup className="gap-2">
              {[0, 1, 2, 3, 4, 5].map((i) => (
                <InputOTPSlot
                  key={i}
                  index={i}
                  className={`h-12 w-11 rounded-xl border text-lg font-semibold first:rounded-l-xl last:rounded-r-xl ${
                    error ? "border-destructive" : ""
                  }`}
                />
              ))}
            </InputOTPGroup>
          </InputOTP>
          {error && (
            <p className="text-sm text-destructive font-medium" data-testid="pin-error-message">{error}</p>
          )}
          <p className="text-xs text-muted-foreground">Transaksi kamu diproses dengan aman</p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => onOpenChange(false)}
            disabled={loading}
            data-testid="pin-confirmation-cancel-button"
          >
            Batal
          </Button>
          <Button
            className="flex-1"
            onClick={() => submit()}
            disabled={pin.length !== 6 || loading}
            data-testid="pin-confirmation-submit-button"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Konfirmasi"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
